import { Plugin } from '@nuxt/types';
import { AlertWithOptions } from '@root/common/types/alerts';
import { AlertComponentProps } from '@core/components/UI/alert/types';

interface AlertHandlerPlugin {
  addAlert: (alert: AlertWithOptions) => Promise<void>;
}

declare module 'vue/types/vue' {
  interface Vue {
    $alertHandler: AlertHandlerPlugin;
  }
}

const alertHandler: Plugin = async ({ store }, inject) => {
  const addAlert = async (alert: AlertWithOptions) => {
    const { closeCallback, ...alertWithoutOptions } = alert;

    const alertForComponent: AlertComponentProps = {
      ...alertWithoutOptions,
      closeCallback: async () => {
        if (closeCallback) {
          closeCallback();
        }
      },
    };

    store.commit('alert', alertForComponent);
  };

  inject('alertHandler', {
    addAlert,
  });
};

export default alertHandler;
